import { LinkOutlined } from '@ant-design/icons';
import styled from 'styled-components';

/**
 * The compare controls, floating on the seam between the A and B groups.
 * Only "sync scroll" for now — the redline/text view toggle is Faza 3 (diff),
 * not wired yet (see PLAN-library-integration.md, Faza 2 "SeamPill bez
 * redline/text toggle-a").
 */

interface ISeamPillProps {
  link: boolean;
  onToggleLink: () => void;
  /** Left offset in px within the editor stage, centred on the A|B seam. */
  left: number;
}

const SeamPill: React.FC<ISeamPillProps> = ({ link, onToggleLink, left }) => (
  <Pill style={{ left }}>
    <PillButton
      $on={link}
      title="Sync scroll of the A ↔ B pair"
      onClick={onToggleLink}
    >
      <LinkOutlined />
    </PillButton>
  </Pill>
);

export default SeamPill;

const Pill = styled.div`
  position: absolute;
  top: 8px;
  transform: translateX(-50%);
  display: flex;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  padding: 2px;
  z-index: 5;
`;

const PillButton = styled.button<{ $on: boolean }>`
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  cursor: pointer;
  color: ${({ theme, $on }) => ($on ? theme.colors.primary : theme.colors.textSecondary)};
  background: ${({ theme, $on }) => ($on ? theme.colors.primaryLight : 'transparent')};
`;
